// extracted by mini-css-extract-plugin
export default {"badgeCol":"listCardHeader_badgeCol__tmn3C","badge":"listCardHeader_badge__HjAdS","label":"listCardHeader_label__01XkI"};